import { AxiosResponse } from "axios"
import { ApiError, ApiResponse } from "../types/global/apiTypes"

export function handleAxiosResponse<T>(response: AxiosResponse<ApiError | T>): ApiResponse<T> {
  if (!response) {
    return {
      statusCode: 500,
      error: { Message: "Ocorreu um erro inesperado." },
    }
  }

  if (response.status != 200) {
    return {
      statusCode: response.status,
      error: response.data as ApiError,
    }
  }

  return {
    statusCode: response.status,
    data: response.data as T,
  }
}